import React from 'react';
import classnames from 'classnames';
import {bem} from '../../utils/bem';
import Icon from './Icon';

const block = bem('button');

const Button = ({
									className = null,
									label = null,
									children = null,
									href = null,
									icon = null,
									onClick = null,
									active = false,
									modifiers = {default: true}
								}) => {
	const Tag = href ? 'a' : 'button';
	return (
		<Tag
			href={href}
			className={classnames(className, block(modifiers), {[bem('js-currentLink')()]: active})}
			onClick={onClick}
		>
			<span className={block('label')}>{children ? children : label}</span>
			{icon && <Icon className={block('icon')} {...icon}/>}
		</Tag>
	);
};

export default Button;
